"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Button_1 = __importDefault(require("../../Button/Button"));
/**
 * A Slide represents a single item within a Carousel.
 */
var Slide = /** @class */ (function (_super) {
    __extends(Slide, _super);
    function Slide(props) {
        return _super.call(this, props) || this;
    }
    Slide.prototype.render = function () {
        var _a = this.props, className = _a.className, image = _a.image, theme = _a.theme, title = _a.title, subtitle = _a.subtitle, content = _a.content, buttonText = _a.buttonText, clickAction = _a.clickAction, rest = __rest(_a, ["className", "image", "theme", "title", "subtitle", "content", "buttonText", "clickAction"]);
        return (React.createElement("div", __assign({}, rest, { className: "slide " + (className ? className : ''), style: { backgroundImage: "url(" + image + ")" } }), (title || content || subtitle) &&
            this.renderContent()));
    };
    Slide.prototype.renderContent = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, content = _a.content, buttonText = _a.buttonText, clickAction = _a.clickAction;
        return (React.createElement("div", { className: "carousel-content" },
            title &&
                React.createElement("h3", { className: "call-to-action" }, title),
            subtitle &&
                React.createElement("div", { className: "subtitle" }, subtitle),
            content &&
                React.createElement("p", { className: "content" }, content),
            (buttonText && typeof clickAction !== 'undefined') &&
                React.createElement(Button_1.default, { className: "action-btn", content: buttonText, onClick: function () { return clickAction(); } })));
    };
    Slide.defaultProps = {
        theme: 'light'
    };
    return Slide;
}(react_1.Component));
exports.default = Slide;
